

export const HAVE_US_CALL_YOU = "have_us_call_you_form"
export const FREE_FOOD_TASTING = "free_food_tasting_form"
export const CONNECT_TO_VM = "connect_to_vm_form"
export const DO_YOU_NEED_ASSISTANCE = "do_you_need_assistance"
export const MAKE_UP_DO_YOU_NEED_ASSISTANCE = "do_you_need_assistance"
export const GET_QUOTE_DO_YOU_NEED_ASSISTANCE = "do_you_need_assistance"
export const FARIDABAD_HAVE_US_CALL_YOU ="faridabad_standalone_have_us_call_you_form"
export const CORPORATE_EVENT_VENUE_ASSISTANCE ="corporate_venues_have_us_call_you_form"

export const ENQUIRY_FORM_TITLE={
    [HAVE_US_CALL_YOU] :{
        formHeading: "Have Us Call You",
        buttonText: "Get Me A Call",
        triggerCode: "huc"
    },
    [FARIDABAD_HAVE_US_CALL_YOU] :{
        formHeading: "Have Us Call You",
        buttonText: "Get Me A Call",
        triggerCode: "faridabad-lp-huc"
    },
    [FREE_FOOD_TASTING] :{
        formHeading :"Free Food Tasting",
        buttonText :"Schedule",
        triggerCode: "fft"
    },
    [CONNECT_TO_VM]:{
        formHeading: "Connect To Venue Manager",
        buttonText:  "Get a Call",
        triggerCode: "ctvm"
    },
    [DO_YOU_NEED_ASSISTANCE]:{
        formHeading: "Do You Need Assistance ",
        buttonText:  "Get a Call Now",
        triggerCode: "dyna"
    },
    [MAKE_UP_DO_YOU_NEED_ASSISTANCE]:{
        formHeading: "Do You Need Makeup Artist",
        buttonText:  "Get a Call Now",
        triggerCode: "mudyna"
    },
    [GET_QUOTE_DO_YOU_NEED_ASSISTANCE]:{
        formHeading: "Do You Need Assistance",
        buttonText:  "Get a Call Now",
        triggerCode: "gqdyna"
    },
    [CORPORATE_EVENT_VENUE_ASSISTANCE]:{
        formHeading: "Do You Need Assistance",
        buttonText:  "Get a Call Now",
        triggerCode: "ceva"
    }
}

